export const STAGE_LIST = [
    {
        id: 0,
        name: 'No Contract',
        statusIcon: 'st-icon-paper',
        icon: 'stage-icon-offer1',
        visible: false
    },
    {
        id: 1,
        name: 'Welcome',
        statusIcon: 'st-icon-paper',
        icon: 'stage-icon-offer1',
        visible: true
    },
    {
        id: 2,
        name: 'Personal Details',
        statusIcon: 'st-icon-person',
        icon: 'stage-icon-personaldetails',
        visible: true
    },
    {
        id: 3,
        name: 'Attachments Review',
        statusIcon: 'st-icon-app',
        icon: 'stage-icon-confirmdocs',
        visible: true
    },
    {
        id: 4,
        name: 'Mobile Confirmation',
        statusIcon: 'st-icon-phone',
        icon: 'stage-icon-mobile',
        visible: true
    },
    {
        id: 5,
        name: 'Summary',
        statusIcon: 'st-icon-paper',
        icon: 'stage-icon-offer1',
        visible: true
    },
    {
        id: 6,
        name: 'Subsequent Login',
        statusIcon: 'st-icon-phone-message',
        icon: 'stage-icon-mobile',
        visible: false
    },
    {
        id: 31,
        name: 'Mobile Confirmation',
        statusIcon: 'st-icon-phone',
        icon: 'stage-icon-mobile',
        visible: false
    },
    {
        id: 40,
        name: 'Summary',
        statusIcon: 'st-icon-paper',
        icon: 'stage-icon-offer1',
        visible: false
    }
];

export const DASHBOARD_ICON = {
        id: 1,
        name: 'Dashboard',
        statusIcon: 'st-icon-paper',
        icon: 'stage-icon-offer1',
        visible: true
    };
export const QUESTION_TYPES = {
    ATTACHMENTS: 'file',
    HTML_CONTENT: 'htmlchunk',
    TASK_LIST: 'task',
    FILE_BLOCK: 'fileblock',
    CALENDAR: 'calendar',
    SOCIAL_LINK: 'sociallink',
    MAP: 'googlemap',
    SIMPLE_LINK: 'simplelink'
};

export const BUTTON_TYPES = {
  ACCEPT: 'ACCEPT',
  QUERY: 'QUERY',
  BACK: 'BACK',
  SEND_MESSAGE: 'SEND MESSAGE',
  NEXT: 'NEXT',
  TASK: 'DO TASK',
  DECLINE: 'DECLINE',
  CONTINUE_DECLINE: 'CONTINUE DECLINE'
};

export const MODEL_KEYS = {
    FILES: '_files'
};

export const VENDOR_KEYS = {
    GOOGLE_MAP: 'AIzaSyDU_rBNIn5A_p-8EEKAk0F2AhyobBj5_GU'
};

export const TYPES = {
    STARTER: 'starter',
    INDUCTEE: 'inductee',
    OFFBOARDEE: 'offboardee'
}

export const TASK_STATUS = {
    46204: 'Pending',
    46205: 'Released',
    46206: 'Overdue',
    46453: 'Completed'
}

export const TASK_STATUS_BUTTON = {
    46204: 'btn-special btn-pending',
    46205: 'btn-special btn-released',
    46206: 'btn-special btn-danger',
    46453: 'btn-special'
}



// WEBPACK FOOTER //
// ./src/app/stage/types/constants.ts